module.exports = __webpack_public_path__ + "static/media/vacciplant.f94433bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pina/climasense/erwinia/preventiva/vacciplant.png
// module id = 2294
// module chunks = 3